import { useState } from 'react';
import { NJButton, NJHeading } from '@engie-group/fluid-design-system-react';
import { RightSideModal } from './RightSideModalFixed';

interface PlantCreateModalProps {
    isOpen: boolean;
    onClose: () => void;
    onSubmit: (data: PlantFormData) => void;
}

interface PlantFormData {
    identifier: string;
    name: string;
    type: 'cold-water' | 'hot-water' | 'steam';
    status: 'active' | 'inactive';
}

const INPUT_STYLE: React.CSSProperties = {
    width: '100%', minHeight: 40, padding: '10px 12px',
    border: '1px solid var(--nj-semantic-color-border-neutral-minimal-default)',
    borderRadius: 4, fontSize: 14, boxSizing: 'border-box',
};

const LABEL_STYLE: React.CSSProperties = {
    display: 'block', fontSize: 14, marginBottom: 6,
};

export function PlantCreateModal({ isOpen, onClose, onSubmit }: PlantCreateModalProps) {
    const [formData, setFormData] = useState<PlantFormData>({
        identifier: '',
        name: '',
        type: 'cold-water',
        status: 'active',
    });

    const handleSubmit = () => {
        if (!formData.identifier || !formData.name) {
            alert('Veuillez remplir tous les champs obligatoires');
            return;
        }
        onSubmit(formData);
        setFormData({ identifier: '', name: '', type: 'cold-water', status: 'active' });
    };

    return (
        <RightSideModal
            isOpen={isOpen}
            onClose={onClose}
            title="Créer une centrale"
            metadata={<>Créé par PROTOTYPER le {new Date().toLocaleDateString('fr-FR')}</>}
            footer={
                <>
                    <NJButton label="Annuler" emphasis="subtle" onClick={onClose} />
                    <NJButton label="Créer" emphasis="bold" onClick={handleSubmit} />
                </>
            }
        >
            {/* Section: Informations générales */}
            <div style={{ marginBottom: 24 }}>
                <NJHeading as="h4" scale="sm" style={{ marginBottom: 16 }}>
                    Informations générales
                </NJHeading>

                <div style={{ marginBottom: 16 }}>
                    <label style={LABEL_STYLE}>Identifiant *</label>
                    <input
                        type="text"
                        value={formData.identifier}
                        onChange={(e) => setFormData({ ...formData, identifier: e.target.value })}
                        placeholder="CBER"
                        style={INPUT_STYLE}
                    />
                </div>

                <div style={{ marginBottom: 16 }}>
                    <label style={LABEL_STYLE}>Nom *</label>
                    <input
                        type="text"
                        value={formData.name}
                        onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                        placeholder="Bercy"
                        style={INPUT_STYLE}
                    />
                    <span style={{ fontSize: 12, color: 'var(--nj-semantic-color-text-neutral-tertiary-default)', marginTop: 4, display: 'block' }}>
                        {formData.name.length}/64
                    </span>
                </div>

                <div style={{ marginBottom: 16 }}>
                    <label style={LABEL_STYLE}>Type *</label>
                    <select
                        value={formData.type}
                        onChange={(e) => setFormData({ ...formData, type: e.target.value as PlantFormData['type'] })}
                        style={INPUT_STYLE}
                    >
                        <option value="cold-water">Eau froide</option>
                        <option value="hot-water">Eau chaude</option>
                        <option value="steam">Vapeur</option>
                    </select>
                </div>

                <div style={{ marginBottom: 16 }}>
                    <label style={LABEL_STYLE}>Statut</label>
                    <select
                        value={formData.status}
                        onChange={(e) => setFormData({ ...formData, status: e.target.value as PlantFormData['status'] })}
                        style={INPUT_STYLE}
                    >
                        <option value="active">Actif</option>
                        <option value="inactive">Inactif</option>
                    </select>
                </div>
            </div>
        </RightSideModal>
    );
}
